import { AddressBookComponent } from './address-book.component';
import { RoleGuard } from '../shared/core/role-guard.service';
import { CompanyItemComponent } from './company-item.component';
import { CanDeactivate } from '@angular/router';
import { PendingChangesGuard } from '../shared/core';

export const routes = [
    {
        path: 'addressbook', component: AddressBookComponent,
        canActivate: [RoleGuard],
        data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE] }
    },
    {
        path: 'addressbook/:companyId', 
        component: CompanyItemComponent,
        canActivate: [RoleGuard],
        canDeactivate: [PendingChangesGuard],
        data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE] }
    },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/address-book.routes.ts